var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgError = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 133,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.682 52.145 84.345 79.72c-1.594 1.594-.877 4.384 1.355 4.941l37.539 9.963a3.011 3.011 0 0 0 3.666-3.666l-10.202-37.46c-.717-2.231-3.427-3.028-5.021-1.354Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.141 20.902 15.882 56.209c-.956 2.072.718 4.384 2.95 4.224l38.654-3.586c2.311-.24 3.507-2.79 2.152-4.703l-22.396-31.72c-1.355-1.913-4.144-1.595-5.1.478Z",
    fill: "#FFD590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.065 25.843-46.944 69.58c-2.79 4.064-.08 9.643 4.862 10.041l83.766 5.898c4.941.319 8.368-4.782 6.216-9.245L74.143 26.64c-2.151-4.463-8.288-4.861-11.078-.797Z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.66 82.432c-1.754-.16-3.11-1.674-2.95-3.427l2.312-32.598c.159-1.753 1.673-3.108 3.427-2.949 1.753.16 3.108 1.674 2.949 3.427l-2.312 32.598c-.16 1.753-1.673 3.028-3.427 2.949ZM64.181 93.59a3.587 3.587 0 1 0 0-7.174 3.587 3.587 0 0 0 0 7.173Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.077 43.059c-1.674.478-3.428-.478-3.906-2.232l-6.535-23.033c-.478-1.674.478-3.428 2.232-3.906 1.673-.478 3.427.479 3.905 2.232l6.535 23.033c.399 1.674-.558 3.428-2.231 3.906ZM30.149 53.977a3.587 3.587 0 1 0 0-7.173 3.587 3.587 0 0 0 0 7.173Z",
    fill: "#28C2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.349 70.873c-1.674-.478-2.631-2.31-2.152-3.985l6.854-22.874c.478-1.673 2.311-2.63 3.985-2.152 1.674.479 2.63 2.312 2.152 3.985l-6.934 22.954a3.048 3.048 0 0 1-3.905 2.072ZM113.117 81.792a3.587 3.587 0 1 0 0-7.173 3.587 3.587 0 0 0 0 7.173ZM28.077 43.059c-1.674.478-3.428-.478-3.906-2.232l-6.535-23.033c-.478-1.674.478-3.428 2.232-3.906 1.673-.478 3.427.479 3.905 2.232l6.535 23.033c.399 1.674-.558 3.428-2.231 3.906ZM30.149 53.977a3.587 3.587 0 1 0 0-7.173 3.587 3.587 0 0 0 0 7.173Z",
    fill: "#3E8EED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.534 17.316c-.478.797-.319 1.754.319 2.391.08.08.24.24.398.24.957.557 2.152.238 2.63-.638l2.471-4.145c.24-.478.32-.956.24-1.514a1.772 1.772 0 0 0-.638-1.036c-.08-.08-.16-.08-.24-.16-.956-.558-2.151-.239-2.63.638l-2.55 4.224ZM84.106 26.164c.08.159.239.398.398.557.638.558 1.515.718 2.232.32l4.144-2.073c.479-.239.797-.637.957-1.116.16-.478.16-1.036-.08-1.514-.16-.24-.319-.478-.558-.638-.16-.159-.398-.239-.558-.318-.478-.16-1.036-.16-1.514.08l-4.144 2.072c-.479.239-.797.637-.957 1.115-.16.558-.16 1.036.08 1.515ZM66.81 15.563c.08.398.24.797.559 1.115.398.399 1.036.638 1.594.558 1.036-.159 1.833-1.115 1.673-2.231l-.717-5.101c-.08-.478-.319-.956-.717-1.275a1.998 1.998 0 0 0-1.514-.399c-1.037.16-1.834 1.116-1.674 2.232l.797 5.1Z",
    fill: "#E1DFDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 81.883,
    y1: 80.657,
    x2: 111.442,
    y2: 74.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#72ACF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7CBF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 35.88,
    y1: 97.932,
    x2: 110.054,
    y2: 33.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6699FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#9699FF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0.6,
    y: 0.21,
    width: 140.8,
    height: 131.967,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3171_111169"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_3171_111169",
    result: "effect2_dropShadow_3171_111169"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3171_111169",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/error.750a736908e6e911944f528bc03ac107.svg";